module.exports = __webpack_public_path__ + "static/media/sunyiwen_match_01.169d20b8.png";